import { _apiV2_delete, _apiV2_get, _apiV2_post } from "@/app/api2"
import {
  CreateNotesRequest,
  CreateNotesResponse,
  DeleteNotesResponse,
  GetNotesByEntityResponse,
  GetNotesResponse,
} from "@/app/types"
import { getToken } from "@/lib/get_token"

const API2URL = `${process.env.API_URL}/api/v2`

export async function createNotes(
  data: CreateNotesRequest
): Promise<CreateNotesResponse> {
  return await _apiV2_post("/notes", {
    key: "notes",
    body: data,
  })
}

export async function getNotes(): Promise<GetNotesResponse> {
  return await _apiV2_get("/notes", {
    key: "getNotes",
  })
}

export async function getNotesByEntity(
  entityId: string,
  entityType: string
): Promise<GetNotesByEntityResponse> {
  return await _apiV2_get(`/notes/${entityType}/${entityId}`, {
    key: `getNotes(${entityId})`,
  })
}

export async function deleteNotes(
  noteKey: string
): Promise<DeleteNotesResponse> {
  return await _apiV2_delete(`/notes/${noteKey}`, {
    key: "notes",
  })
}

export async function getFile(
  fileName: string,
  noteKey: string
): Promise<{ url: string }> {
  return await _apiV2_get(`/notes/${noteKey}/files/${fileName}`, {
    key: "getFile",
  })
}

export async function uploadFiles(data: FormData, noteKey: string) {
  try {
    const token = await getToken()

    const response = await fetch(`${API2URL}/notes/${noteKey}/files`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    })

    return response
  } catch (error) {
    console.error("Error uploading files", error)
    throw error
  }
}

export async function deleteFile(
  fileName: string,
  noteKey: string
): Promise<void> {
  return _apiV2_delete(`/notes/${noteKey}/files/${fileName}`, {
    key: "deleteFile",
  })
}
